import { render } from "./activityAdd.vue?vue&type=template&id=6978ce76&scoped=true"
import script from "./activityAdd.vue?vue&type=script&lang=js"
export * from "./activityAdd.vue?vue&type=script&lang=js"

import "./activityAdd.vue?vue&type=style&index=0&id=6978ce76&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6978ce76"]])

export default __exports__